import "./App.css";
import Home from "./Home";
import Nav from "./components/Nav.js";

function App() {
	return (
		<div className="bg-gray-900">
			<Nav />
			<Home />
		</div>
	);
}

export default App;
